import { ApiFilterValue } from "@/modules/api/api-filter-value.type";

export enum FactoryInvoiceTypeValue {
  SHIPMENT = 1,
  PERIODICAL = 2,
  BATCH_DEPOSIT = 3,
  BATCH_BALANCE = 4,
  DEPOSIT = 5,
}

export const regularFactoryInvoiceTypes = [
  FactoryInvoiceTypeValue.SHIPMENT,
  FactoryInvoiceTypeValue.PERIODICAL,
  FactoryInvoiceTypeValue.DEPOSIT,
];

export const batchFactoryInvoiceTypes = [
  FactoryInvoiceTypeValue.BATCH_DEPOSIT,
  FactoryInvoiceTypeValue.BATCH_BALANCE,
];

export function getFactoryInvoiceDetailRouteName(
  type: FactoryInvoiceTypeValue
): "FactoryInvoiceViewPage" | "BatchInvoiceViewPage" {
  return batchFactoryInvoiceTypes.includes(type)
    ? "BatchInvoiceViewPage"
    : "FactoryInvoiceViewPage";
}

export function getFactoryInvoiceTypeName(
  type: FactoryInvoiceTypeValue,
  usedDepositPercent?: number
): string {
  if (type === FactoryInvoiceTypeValue.DEPOSIT) {
    return "Deposit";
  }

  if (type === FactoryInvoiceTypeValue.PERIODICAL) {
    return "Periodical";
  }

  if (type === FactoryInvoiceTypeValue.BATCH_DEPOSIT) {
    return usedDepositPercent == null
      ? "Deposit"
      : `${usedDepositPercent}% Deposit`;
  }

  if (type === FactoryInvoiceTypeValue.BATCH_BALANCE) {
    return "Balance";
  }

  return "Shipment";
}

export function getRegularFactoryInvoiceTypeFilter(
  selectedType: unknown
): ApiFilterValue {
  if (typeof selectedType !== "string" && typeof selectedType !== "number") {
    return regularFactoryInvoiceTypes;
  }

  return regularFactoryInvoiceTypes.some(
    (type) => selectedType === type || selectedType === String(type)
  )
    ? selectedType
    : regularFactoryInvoiceTypes;
}
